import React from 'react';
import * as classes from './Switch.module.css';

const Switch = ({ checked = false, onChange }) => {
  return (
    <label className={classes.container}>
      <input
        type="checkbox"
        onChange={() => onChange(!checked)}
        checked={checked}
      ></input>
      <span className={classes.slider}></span>
    </label>
  );
};

export default Switch;
